import { SkeletonTile } from '../SkeletonTile';

const slidesPerView = 4;

const GiftBoxRelatedProductsFallback = () => {
    return (
        <div className="grid">
            {[...Array.from({ length: slidesPerView }).keys()].map(id => (
                <div className="g-col-6 mb-2x" key={`skeleton-${id}`}>
                    <SkeletonTile />
                </div>
            ))}
        </div>
    );
};

export { GiftBoxRelatedProductsFallback };
